import React from 'react'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import Layout from 'src/components/layouts'
import HowItWorks from 'src/components/pages/BrandPages/HowItWorks'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'
import { getMegamenuData } from 'src/common/back/megamenu'

export async function getServerSideProps(context) {
  const jsonLdSchemas = await getContentfulJsonLd('how-it-works/')
  let megamenuData = null
  try {
    megamenuData = await getMegamenuData(context)
  } catch (error) {
    console.error('How-it-works page: Error fetching megamenu', error)
  }

  return {
    props: {
      jsonLdSchemas,
      isCrawler: false,
      megamenuData: megamenuData || null,
    },
  }
}

const HowItWorksPage = ({ megamenuData, jsonLdSchemas }) => (
  <>
    <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
    <Layout
      crawlable={true}
      isBrandPage={true}
      footerClassName="mb-5 lg:mb-0"
      dashboardClass="bg-blue-300 text-white"
      megamenuData={megamenuData}
    >
      <HowItWorks />
    </Layout>
  </>
)

export default HowItWorksPage
